import { render, staticRenderFns } from "./ListByClient.vue?vue&type=template&id=5cd2c88e&"
import script from "./ListByClient.vue?vue&type=script&lang=js&"
export * from "./ListByClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports